let storeNames = [];
let availableLocations = [];

(async () => {
    try {
      // Step 1: Fetch the first available variant's inventory_item_id
      const variantsResponse = await fetch('/admin/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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'
        },
        body: JSON.stringify({
          query: `
            query {
              product(id: "gid://shopify/Product/9716613546265") {
                variants(first: 1) {
                  edges {
                    node {
                      inventoryItem {
                        id
                      }
                    }
                  }
                }
              }
            }
          `
        })
      });
  
      if (!variantsResponse.ok) {
        throw new Error(`HTTP error! status: ${variantsResponse.status}`);
      }
  
      const variantsData = await variantsResponse.json();
      const firstInventoryItemId = variantsData.data.product.variants.edges[0]?.node.inventoryItem.id.replace(
        'gid://shopify/InventoryItem/',
        ''
      );
  
      if (!firstInventoryItemId) {
        console.error('No inventory item found for the selected variant.');
        return;
      }
  
      // Step 2: Fetch inventory levels for the first inventory item
      const inventoryResponse = await fetch(
        `/admin/api/2024-10/inventory_levels.json?inventory_item_ids=${firstInventoryItemId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Access-Token': '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'
          }
        }
      );
  
      if (!inventoryResponse.ok) {
        throw new Error(`HTTP error! status: ${inventoryResponse.status}`);
      }
  
      const inventoryData = await inventoryResponse.json();
  
      // Step 3: Fetch location details
      const locationsResponse = await fetch('/admin/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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'
        },
        body: JSON.stringify({
          query: `
            query {
              locations(first: 50) {
                edges {
                  node {
                    id
                    name
                    address {
                      formatted
                    }
                  }
                }
              }
            }
          `
        })
      });
  
      if (!locationsResponse.ok) {
        throw new Error(`HTTP error! status: ${locationsResponse.status}`);
      }
  
      const locationsData = await locationsResponse.json();
      const locationsMap = locationsData.data.locations.edges.reduce((map, edge) => {
        const locationId = edge.node.id.replace('gid://shopify/Location/', '');
        map[locationId] = {
          name: edge.node.name,
          address: edge.node.address.formatted.join(', ')
        };
        return map;
      }, {});
  
      // Step 4: Display inventory location details for the selected variant
      const inventoryContainer = document.querySelector('.inventory-locations'); // Ensure this element exists in your HTML
  
      if (inventoryData.inventory_levels.length > 0) {
        inventoryContainer.innerHTML = ''; // Clear previous entries
        inventoryData.inventory_levels.forEach((level) => {
          const locationDetails = locationsMap[level.location_id] || { name: 'Unknown', address: 'N/A' };
          let handleizeNAme = locationDetails.name.replace(/ /g, '-').toLowerCase();
          const locationHTML = `
            
            <p data-store-name=${handleizeNAme} data-inventory-count=${level.available}>${locationDetails.name}: ${level.available} in stock</p>
          `;
          inventoryContainer.insertAdjacentHTML('beforeend', locationHTML);
        });
      } else {
        inventoryContainer.innerHTML = '<p>No inventory available for the selected variant.</p>';
      }
  
      console.log(' pramodInventory Levels with Locations:', inventoryData, locationsMap);
  
    } catch (error) {
      console.error('Error:', error);
    }
  })();


function getAvailableLocations(handleizedNames) {
  return new Promise((resolve) => {
      availableLocations = []; // Reset array before processing

      // Select all inventory locations dynamically
      const locations = document.querySelectorAll('.inventory-locations p');

      locations.forEach((location) => {
          const storeName = location.getAttribute('data-store-name');
          const inventoryCount = parseInt(location.getAttribute('data-inventory-count'), 10);

          // Check if store name is in the given list and has stock available
          if (handleizedNames.includes(storeName) && inventoryCount >= 1) {
              availableLocations.push({
                  storeName: storeName,
                  inventoryCount: inventoryCount
              });
          }
      });

      console.log('Pramod availableLocations:', availableLocations);
      resolve(availableLocations); // Resolve the promise after processing
  });
}

function waitForInventoryLoad(callback) {
    const targetNode = document.querySelector('.inventory-locations');

    if (!targetNode) {
        console.error("Inventory container not found!");
        return;
    }

    const observer = new MutationObserver(async (mutations, obs) => {
        if (document.querySelectorAll('.inventory-locations p').length > 0) {
            obs.disconnect(); // Stop observing once elements are available
            await getAvailableLocations(storeNames); // Wait for locations to be processed
            callback(); // Now execute the callback
        }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
}

// Call the observer function
waitForInventoryLoad(() => {
    console.log('Processing stores now...');
    handleStoreData("123", "321");
});

async function getStoreReviews() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition_store, showError);
    } else {
        console.log(" pramodGeolocation is not supported by this browser.");
    }
}

async function callStoreAPI() {
    storeNames = []; // Reset the array before fetching new data

    var get_lat_lng = localStorage.getItem('location_store');
    var obj = JSON.parse(get_lat_lng);

    var lat = obj.latitude;
    var lan = obj.longitude;

    var url = obj.postal && obj.store ?
        `${storeApiUrl}/near-by?latitude=${lat}&longitude=${lan}` :
        `${storeApiUrl}/near-by?city=${obj.state}`;

    try {
        const response = await $.get(url);
        return response;
    } catch (error) {
        throw new Error('Error fetching store data: ' + error.message);
    }
}

function showError(error) {
    let latitude, longitude;
    if (error.code === error.PERMISSION_DENIED) {
        console.log(" pramodUser denied the request for Geolocation.");
        const locationStore = localStorage.getItem('location_store');
        const locationData = JSON.parse(locationStore);
        latitude = locationData.latitude;
        longitude = locationData.longitude;
        handleStoreData(latitude, longitude);
    } else {
        console.log(`Geolocation error: ${error.message}`);
    }
}

function showPosition_store(position) {
    const { latitude, longitude } = position.coords;
    handleStoreData(latitude, longitude);
}

async function handleStoreData(latitude, longitude) {
    try {
        const data = await callStoreAPI(latitude, longitude);
        if (data.storeList.length > 0) {
            console.log(' pramodpramod', data.storeList);
            updateStoreHTML(data.storeList, data);
        } else {
            $(".ct_more_store").hide();
        }
    } catch (error) {
        console.error(error);
    }
}

function updateStoreHTML(storeList, data) {
    storeNames = storeList.map(store => store.storeNameCode ? store.storeNameCode.replace(/ /g, '-').toLowerCase() : ''); // Store all store names in the array
    console.log(' pramodstoreList', storeNames , availableLocations );

    let storeHTML = '';
    const storesToShow = storeList.slice(0, 20);
    let hidden_class = storesToShow.length < 4 ? "hidden" : "";

    var jsonString = localStorage.getItem('location_store');
    var jsonObject = JSON.parse(jsonString);
    var store_city = jsonObject['state'] ?
        `<a href="https://www.kushals.com/pages/store/${data.slug}">View All</a>` :
        `<a href="https://www.kushals.com/pages/stores/">View All</a>`;

    storesToShow.forEach(store => {
        var openingTime = convertTo12HourFormat(store.openingTime);
        var closingTime = convertTo12HourFormat(store.closingTime);
        var open_time = openingTime.split(" ");
        var close_time = closingTime.split(" ");
        var time_check_store_open_close = updateStoreTime(open_time[0], store.closingTime, closingTime);
        var city = jsonObject['state'] ? jsonObject['state'] + "-" + store.slug : "";
        let StoreAvailable = false;

      console.log('Pramod availableLocations', availableLocations)

        availableLocations.forEach(location => {
            if (location.storeName === store.storeNameCode.replace(/ /g, '-').toLowerCase()) {
                StoreAvailable = true;
            }
        });

        storeHTML += `
                          <div class="store-more-box store-more-box-product">
                              <div class="store-more-box-inner">
                                  <a class="store_pro-link ct_store_click" data-store="${store.name}" href="https://www.kushals.com/pages/store-details/${city}">
                                      ${store.storeNameCode} - ${StoreAvailable ? 'In Stock' : 'Out of Stock'}
                                      <div class="store-more-box-head">
                                          <div class="store-more-name">
                                              <span>${store.name}</span>
                                          </div>
                                          <div class="store-more-star">
                                              <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/google.png?v=1721205440" width="30" height="30">
                                              <span>${store.rating}</span>
                                          </div>
                                      </div>
                                      <div class="store-more-text">${store.address}</div>
                                  </a>
                                  <div class="call-dir-main">
                                      <a href="tel:+91${store.phone}" class="ct_store_call" data-store="${store.name}">
                                          <div class="call-main">
                                              <div class="call-icon">
                                                  <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/fluent_call-28-regular.png?v=1719300254" alt="">
                                              </div>
                                              <span>Call Store</span>
                                          </div>
                                      </a>
                                      <div class="direction-main">
                                          <div class="direction-icon">
                                              <img src="https://cdn.shopify.com/s/files/1/0796/1959/files/teenyicons_direction-solid.png?v=1719300137" alt="">
                                          </div>
                                          <span><a class="ct_store_map" data-store="${store.name}" href="${store.direction}" target="_blank">Get Direction</a></span>
                                      </div>
                                      ${time_check_store_open_close}
                                  </div>
                              </div>
                          </div>`;
    });

    const finalHTML = `
                      <div class="store-more-head">
                          <span>Stores Near You To Assist</span>
                          <div class="store-more-all ct_all_store ${hidden_class}">${store_city}</div>
                      </div>
                      <div class="store-more-content">${storeHTML}</div>`;

    $(".ct_more_store").html(finalHTML);
    $(".ct_more_store").show();
}

function convertTo12HourFormat(time) {
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
}

function updateStoreTime(open_time, close_time, store_close_time) {
    var currentTime = new Date();
    var openingDate = new Date(currentTime);
    var closingDate = new Date(currentTime);
    var [closeHours, closeMinutes] = close_time.split(':').map(Number);
    closingDate.setHours(closeHours, closeMinutes);
    if (closingDate <= openingDate) closingDate.setDate(closingDate.getDate() + 1);

    return (currentTime >= openingDate && currentTime < closingDate) ?
        `<div class="open-close-store"> <div class="dot"></div> <span>Open</span> </div>` :
        `<div class="open-close-store close_store"> <div class="dot"></div> <span>Closed</span> </div>`;
}

handleStoreData("123", "321");